module.exports = __webpack_public_path__ + "static/api-a8e61eee341381c062409b66f291e350.svg";